import React from "react";
import SelectMenu from "../../controls/SelectMenu";
import Input from "../../controls/Input";
import DatePickerInput from "../../controls/DatePickerInput";

const fieldClassName =
  "mt-1.5 block w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm shadow-sm placeholder:text-slate-400 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30";

export default function SunDistributionDetailsSection(props: any) {
  const {
    values,
    errors,
    handleInputChange,
    customers,
    showExtraFields = false,
    showHeader = true,
  } = props;

  return (
    <div className="w-full space-y-5">
      {showHeader ? (
        <div>
          <h3 className="text-base font-semibold text-slate-900">
            Order details
          </h3>
          <p className="mt-1 text-sm text-slate-500">
            {showExtraFields
              ? "Customer, shipping, and order information"
              : "Customer, PO, and order date"}
          </p>
        </div>
      ) : null}

      <div
        className={
          showExtraFields
            ? "grid grid-cols-1 gap-3 sm:grid-cols-2"
            : "space-y-4"
        }
      >
        <SelectMenu
          handleInputChange={handleInputChange}
          name="customer"
          options={customers}
          value={values.customer}
          title="Customer *"
          error={errors.customer}
          showLabel={true}
          parentClass={showExtraFields ? "col-span-2" : "w-full"}
        />

        <Input
          label="PO # *"
          name="po_number"
          onChange={handleInputChange}
          value={values.po_number}
          labelOn={true}
          type="text"
          error={errors.po_number}
          className={fieldClassName}
        />

        {showExtraFields ? (
          <Input
            label="Customer PO Number"
            name="sun_customer_po_number"
            onChange={handleInputChange}
            value={values.sun_customer_po_number}
            labelOn={true}
            type="text"
            autoComplete="off"
            className={fieldClassName}
          />
        ) : null}

        <DatePickerInput
          label="Order Date *"
          name="order_date"
          onChange={handleInputChange}
          value={values.order_date}
          labelOn={true}
          minDate={new Date()}
          dateFormat="LLL dd, yyyy"
          type="text"
          className={fieldClassName}
          error={errors.order_date}
        />

        {showExtraFields ? (
          <>
            <DatePickerInput
              label="Expected Date"
              name="expected_date"
              onChange={handleInputChange}
              value={values.expected_date ? values.expected_date : null}
              labelOn={true}
              minDate={new Date()}
              dateFormat="LLL dd, yyyy"
              type="text"
              className={fieldClassName}
              error={errors.expected_date}
            />

            <Input
              label="BOL Number"
              name="bill_of_lading"
              onChange={handleInputChange}
              value={values.bill_of_lading}
              labelOn={true}
              type="text"
              autoComplete="off"
              className={fieldClassName}
            />

            <Input
              label="Appointment Number"
              name="appointment_number"
              onChange={handleInputChange}
              value={values.appointment_number}
              labelOn={true}
              type="text"
              autoComplete="off"
              className={fieldClassName}
            />

            <Input
              label="Temperature Recorder Number"
              name="temperature_recorder_number"
              onChange={handleInputChange}
              value={values.temperature_recorder_number}
              labelOn={true}
              type="text"
              autoComplete="off"
              className={fieldClassName}
            />

            <Input
              label="Pallet Count"
              name="pallet_count"
              onChange={handleInputChange}
              value={values.pallet_count}
              labelOn={true}
              type="text"
              autoComplete="off"
              className={fieldClassName}
            />

            <Input
              label="Chep Pallet Count"
              name="chep_pallet_count"
              onChange={handleInputChange}
              value={values.chep_pallet_count}
              labelOn={true}
              type="text"
              autoComplete="off"
              className={fieldClassName}
            />

            <Input
              label="Total Freight Weight"
              name="total_freight_weight"
              onChange={handleInputChange}
              value={values.total_freight_weight}
              labelOn={true}
              type="text"
              autoComplete="off"
              className={fieldClassName}
            />

            <Input
              label="Carrier Name"
              name="carrier_name"
              onChange={handleInputChange}
              value={values.carrier_name}
              labelOn={true}
              type="text"
              autoComplete="off"
              className={fieldClassName}
            />

            <Input
              label="Seal #"
              name="seal_number"
              onChange={handleInputChange}
              value={values.seal_number}
              labelOn={true}
              type="text"
              autoComplete="off"
              className={fieldClassName}
            />

            <Input
              label="WFP Text"
              name="wfp_text"
              onChange={handleInputChange}
              value={values.wfp_text}
              labelOn={true}
              type="text"
              autoComplete="off"
              className={fieldClassName}
            />

            <Input
              label="WFP Load ID Number"
              name="wfp_load_id_number"
              onChange={handleInputChange}
              value={values.wfp_load_id_number}
              labelOn={true}
              type="text"
              autoComplete="off"
              className={fieldClassName}
            />

            <Input
              label="WFP Pickup Date"
              name="wfp_pickup_date"
              onChange={handleInputChange}
              value={values.wfp_pickup_date}
              labelOn={true}
              type="text"
              autoComplete="off"
              className={fieldClassName}
            />

            <Input
              label="WFP Gate In / Gate Out Times"
              name="wfp_gate_in_gate_out_times"
              onChange={handleInputChange}
              value={values.wfp_gate_in_gate_out_times}
              labelOn={true}
              type="text"
              autoComplete="off"
              className={fieldClassName}
            />
          </>
        ) : null}
      </div>
    </div>
  );
}
